import { BuildProduct } from './../constants/actionType'
// const appInitialState = {
//   referralUrl: "",
//   flowType     : "",
//   title        : "Ordering",
//   selectedState: {},
//   showCity     : false,
//   visitId      : "",
//   visitorId    : "",
//   prevPage     : "",
//   vendor       : {
//     vendorName: "",
//     vendorUrl : "",
//     vendorTN  : ""
//   },
//   isTargetOrdering: false,
//   currentPage     : "",
//   mon_no          : "",
//   mon_invoked     : false,
//   mobileHelpReveal: false,
//   isCartDirty     : false,
//   lboMessage: "" ,
//   isLoader        : {
//       isLoaderActive: false,
//       isLoaderText  : "Just a moment,<br/> we're looking it up now.",
//       isLoaderImg   : "spinner",
//       loaderCount   : 0
//   },
//   ecHeader   : 'Loading...',
//   ecFooter   : 'Loading...',
//   pgLoggerObj: {
//     enableUserAction: false,
//     enableApiTiming : false,
//     enablePageLoad  : false
//     }
// }

//define a reducer with an initialized state action

const strAppInitialState = `{
    "referralUrl": "",
    "flowType": "",
    "flowRoute": "",
    "flowPurpose": "",
    "AccordionStatus":"",
    "title": "Ordering",
    "selectedState": {},
    "showCity": false,
    "visitId": "",
    "visitorId": "",
    "lqStreamlineBanner": null,
    "lqHomeLoaded": false,
    "setBrowerInfoInvoked":false,
    "prevPage": "",
    "vendor": {
      "vendorName": "",
      "vendorUrl": "",
      "vendorTN": "",
      "dig": ""
    },
    "isTargetOrdering": false,
    "currentPage": "",
    "mon_no": "",
    "mon_invoked": false,
    "mobileHelpReveal": false,
    "isCartDirty": false,
    "lboMessage": "",
    "isLoader": {
      "isLoaderActive": false,
      "isLoaderText": "Just a moment,<br/> we're looking it up now.",
      "isLoaderImg": "spinner",
      "loaderCount": 0,
      "isHoaLoader":false,
      "hoaLoadertext":""
    },
    "pgLoggerObj": {
      "enableUserAction": false,
      "enableApiTiming": false,
      "enablePageLoad": false
    },
    "movesEligibility":"",
    "userInfo": "",
    "queryString":""
  }`;
  // Testing to reduce Initiial state load parse time

  //define a reducer with an initialized state action
  const  appInitialState = JSON.parse(strAppInitialState);


//define a reducer with an initialized state action
function app(state = appInitialState, action) {
  //eventually adding logic to handle create, update, and delete
    switch (action.type) {
        //move Change
        case 'UPDATE_FLOWTYPE':
            return Object.assign({}, state, {
                flowType:action.value.flowType
            }) 
        case 'UPDATE_FLOWPURPOSE':
            return Object.assign({}, state, {
                flowPurpose:action.value.flowPurpose
            })     
        case 'UPDATE_FLOWROUTE':
            return Object.assign({}, state, {
                flowRoute:action.value
            }) 
        case 'ACCORDIONSTATUS':
            return Object.assign({}, state, {
                AccordionStatus:action.value
            }) 
        case 'UPDATE_USERINFO':
            return Object.assign({}, state, {
                userInfo:action.value
            })                                          
        case 'UPDATE_VISITID':
            const {visitId,visitorId} = action.value;
            return Object.assign({}, state, {
                visitId,
                visitorId
            })  
        case 'SET_BROWSERINFO_INVOKED':
            return Object.assign({}, state, {
                setBrowerInfoInvoked:action.value
            })
        case 'SET_QUERYSTRING': 
            return Object.assign({}, state, {
                queryString: action.value
            })     
        case 'PAGE_VISITID': 
            return Object.assign({}, state, {
                prevPage   : action.value.prevPage,
                currentPage: action.value.currentPage
            }) 
        case 'UPDATE_LOGGEROBJ': 
            let loggerObj = Object.assign({}, state.pgLoggerObj, {
                enableUserAction: action.value.enableUserAction,
                enableApiTiming : action.value.enableApiTiming,
                enablePageLoad  : action.value.enablePageLoad
            })
            return Object.assign({}, state, {
                pgLoggerObj: loggerObj
            })  
        case 'VENDOR_DETAILS': 
            let vendorDetails = Object.assign({}, state.vendor, {
                vendorName: action.value.vendor_name,
                vendorUrl : action.value.vendor_url,
                vendorTN  : action.value.default_tn,
                dig : action.value.dig
            })
            return Object.assign({}, state, {
                vendor: vendorDetails
            })
        case 'IS_TARGETORDERING': 
            return Object.assign({}, state, {
                isTargetOrdering: action.value
            })
        case BuildProduct.monNo:             
            return Object.assign({}, state, {
                mon_no: action.value
            })
        case BuildProduct.monInvoked: 
            return Object.assign({}, state, {
                mon_invoked: action.value
        })
        case 'MOBILE_HEADER': 
            return Object.assign({}, state, {
                mobileHelpReveal: !action.value
        })  
        case 'SET_CART_DIRTY': 
            return Object.assign({}, state, {
                isCartDirty: action.value
        })    
        case 'CANCEL_MON': 
            return Object.assign({}, state, {
                mon_no     : '',
                mon_invoked: false
        })
        case 'UPDATE_LBO':
            return Object.assign({}, state, {
                lboMessage: action.value
        })
        case 'SET_REFERRAL_URL':
            return Object.assign({}, state, {
                referralUrl: action.value
        })

        case 'EC_HEADER': 
            return (Object.assign({}, state, {
                ecHeader: action.value || 'Failed to fetch Content'
            }))
        case 'EC_FOOTER': 
            return (Object.assign({}, state, {
                ecFooter: action.value || 'Failed to fetch Content'
            }))
        case "LOADER_HOA":
            let hoaLoaderactive = "";
            
            if (action.value.isLoaderActive === true) {
            hoaLoaderactive = Object.assign({}, state.isLoader, {
                isHoaLoader : action.value.isLoaderActive,
                hoaLoadertext  : action.value.hoaLoadertext ? action.value.hoaLoadertext :"",
            })
            }else{
                hoaLoaderactive = Object.assign({}, state.isLoader, {
                    isHoaLoader : action.value.isLoaderActive,
                    hoaLoadertext  : "",
                })
            }
            return Object.assign({}, state, {                    
                isLoader: hoaLoaderactive
            })
        case 'LOADER_ACTIVE': 
            let loaderactive = "";
            if((action.value.isLoaderText !== undefined || action.value.isLoaderImg!== undefined) &&
              action.value.isLoaderActive === true){
                loaderactive = Object.assign({}, state.isLoader, {  
                    isLoaderActive: action.value.isLoaderActive,
                    isLoaderText  : action.value.isLoaderText,
                    isLoaderImg   : action.value.isLoaderImg,
                    loaderCount   : state.isLoader.loaderCount + 1
                })
            }
            else if (action.value.isLoaderActive === true) {
                loaderactive = Object.assign({}, state.isLoader, {
                    isLoaderActive: action.value.isLoaderActive,
                    isLoaderText  : "",
                    loaderCount   : state.isLoader.loaderCount + 1
                })
            }
            else if (state.isLoader.loaderCount <= 1) {
                loaderactive = Object.assign({}, state.isLoader, {
                    isLoaderActive: action.value.isLoaderActive,
                    isLoaderText  : "",
                    loaderCount   : 0
                })
            }
            else {
                loaderactive = Object.assign({}, state.isLoader, {
                    loaderCount: state.isLoader.loaderCount - 1
                })
            }
            return Object.assign({}, state, {                    
                isLoader: loaderactive
            })
        case 'MOVE_ELIGIBILITY':
            return Object.assign({},state,{
                movesEligibility:action.value
            })
            case "LQ_STREAMLINE_BANNER_AEM": {
                return Object.assign({}, state, {
                    lqStreamlineBanner: action.value
            })
        }
        case "LQ_Home_Loaded": {
            return Object.assign({}, state, {
                lqHomeLoaded: action.value
        })
    }
        default: 
            return state
    }
}

export default app